<template>
  <pa-header></pa-header>

  <div class="container-fluid px-8">
    <div class="row">
      <h2 class="text-center text-[30px] mb-4 ">Please select a channel to play</h2>
      <div class="grid grid-cols-5 gap-5">
        <div v-for="(channel,index) in channels" v-bind:key="index">
          <a v-bind:tabindex="5+index" @click="openVideo(channel)" @keyup.enter='openVideo(channel)'
             class="video block py-16 rounded video mb-4 d-block cursor-pointer hover:bg-red-700 hover:text-white">
            <img v-bind:src="'images/'+channel.flag+'.svg'" alt="" style="width: 100px;height: 80px;display: block ;  margin: auto; margin-bottom: 20px">
            <span class="font-oswald text-3xl uppercase">{{ channel.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="text-center flex items-center justify-center py-40" v-if="loading">
    <div class="lds-ripple">
      <div></div>
    </div>
    Loading please wait...
  </div>
</template>
<script>
import axios from "axios";
import PaHeader from "@/views/Pa-Header";

var SpatialNavigation = window.SpatialNavigation;
export default {
  components: {PaHeader},
  data() {
    return {
      channels: [],
      loading: false,
    }
  },
  methods: {
    openVideo(v) {
      var to = {
        name: "pa-stream", //use name for router push
        params: {id: v.link}
      };
      window.localStorage.setItem('vlink', v.link);
      this.$router.push(to);
    }
  },
  mounted() {
    var el = document.querySelectorAll('.router-link-exact-active')[0];
    if (el) el.classList.add('active6');
    SpatialNavigation.focus('.router-link-exact-active');
    this.$data.loading = true;
    axios
        .get('http://tv.primeasianews.com/api/channels.php')
        .then(res => {
          this.$data.channels = [...res.data.video_streams];
          setTimeout(() => {
            SpatialNavigation.makeFocusable();
            SpatialNavigation.focus();
          }, 200)

        })
        .catch(() => {
          this.$data.channels = [{name: 'Prime Asia Tv', link: 'http://primeasia.dyndns.tv/Live_720p_Web/index.m3u8'}];
        }).finally(() => {
      this.$data.loading = false;
    })
  }
}
</script>
<style lang="scss">

</style>
